import { branchRoutes } from '@/lib/route-paths';
import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect shim. The client profile moved to `/dashboard/customers/$leadId`
 * with the unified Clients surface. This path is the one most likely to be
 * deep-linked — it is what every "view this client" link we have ever sent
 * points at — so it forwards rather than 404s. See `clients/list.tsx`.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/clients/$leadId'
)({
  // `branchRoutes`, not `useBranchRoutes()`: `beforeLoad` runs outside render,
  // where a hook throws instead of redirecting — and the throw re-ran the
  // navigation in a loop until the dashboard error boundary took the page.
  beforeLoad: ({ params }) => {
    throw redirect({
      to: branchRoutes(params.locationId).customerDetail(params.leadId),
    });
  },
});
